/**
 * Brand tokens for the console — sourced from @solum/experience (the single
 * source of truth shared with the L0 renderer). Adding a customer brand is
 * adding a BrandTokens object here; nothing in any component changes.
 */
import { MOONBASE, SOLUM, ACME, type BrandTokens } from '@solum/experience'

export type { BrandTokens }
// Moonbase leads — the console's default brand (the 06/2026 relaunch identity).
// PLATFORM brands only. A CUSTOMER brand (e.g. Coccolare) must NOT ship in the
// shared console — that leaks one tenant's identity into every tenant's switcher.
// A customer brand travels IN its solution: the deployment's `platform|brand`
// setting carries the full tokens and BrandSync hydrates them at startup.
export const BRANDS: BrandTokens[] = [MOONBASE, SOLUM, ACME]
export type ThemeMode = 'light' | 'dark' | 'system'

/**
 * How a PROMINENT header is coloured — independent of the page theme (#2347 §1).
 *
 * `match` follows the active page surface; `contrast` uses the governed inverse
 * pair even while the page is light. Two values and no more: §1 rules out
 * `light headers`, colour pickers, opacity sliders and per-page overrides by
 * name, and a finite union is the only shape under which that cannot be
 * widened by a stored string.
 *
 * It is a SEPARATE axis from `ThemeMode`, not a fourth mode, because the two
 * answer different questions — "is this workspace light or dark" and "does its
 * product header stand apart from it". Folding them into one control is what
 * forces the false choice #2347 exists to remove.
 */
export type HeaderTreatment = 'match' | 'contrast'
